import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';

import { TypedDialogModule } from '@libs/src/typed-dialog/typed-dialog.module';

import { DialogConfirmPromptService } from './dialog-confirm-prompt.service';

import { DialogConfirmPromptComponent } from './dialog-confirm-prompt.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    TypedDialogModule,
    NzOutletModule,
  ],
  declarations: [DialogConfirmPromptComponent],
  exports: [DialogConfirmPromptComponent],
  providers: [DialogConfirmPromptService],
})
export class DialogConfirmPromptModule {}
